import './Reviews.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Rev1 from '../../assets/rev1.png';
import Rev2 from '../../assets/rev2.png';
import Rev3 from '../../assets/rev3.png';
import HPE from '../../assets/HPE.svg';
import Crunchyroll from '../../assets/Crunchyroll.svg';

const Reviews = () => {
  const navigate = useNavigate();

  return (
    <div className='reviews'>
      <span className='reviewsTitle'>Experts About Us</span>
      <div className='review'>
        <div className='reviewDetails'>
          <span className='reviewAvatar'>
            <img src={Rev1} />
          </span>
          <span className='reviewName'>
            Tina Griffin,<span className='reviewRole'>Sr. Talent Acquisition, HPE</span>
          </span>
        </div>
        <div className='reviewContent'>
          <span className='reviewTitle'>“It is refreshing to be able to rely on the expertise of his team…”</span>
          <span className='reviewText'>
            “Kim and his team are polished professionals who deliver high-quality candidates in a timely manner. It is refreshing
            to be able to rely on the expertise of his team when searching for all skill sets required for contract positions.”
          </span>
          <span className='reviewLogo'>
            <img src={HPE} />
          </span>
        </div>
      </div>

      <div className='review'>
        <div className='reviewDetails'>
          <span className='reviewAvatar'>
            <img src={Rev2} />
          </span>
          <span className='reviewName'>
            Michael Maher, <span className='reviewRole'>Sr. DevOps Engineer</span>
          </span>
        </div>
        <div className='reviewContent'>
          <span className='reviewTitle'>
            “The experience is much like walking into ‘Ollivanders Wand Shop’ from Harry Potter….”
          </span>
          <span className='reviewText'>
            “I had the great pleasure to work with Richard at Rubicon Project. The experience is much like walking into
            ‘Ollivanders Wand Shop’ from Harry Potter. See, in the shop there are many magic wands, but only 'one' of them is
            really right for you and this is what it feels like when you are looking at resumes for an open position.”
          </span>
        </div>
      </div>

      <div className='review'>
        <div className='reviewDetails'>
          <span className='reviewAvatar'>
            <img src={Rev3} />
          </span>
          <span className='reviewName'>
            Tiffany Rabara, <span className='reviewRole'>Director, Talent Acquisition (Poland, Puerto Rico, & U.S.), BOLD</span>
          </span>
        </div>
        <div className='reviewContent'>
          <span className='reviewTitle'>
            “We were able to have an organic conversation right away. I felt like it was a mutual partnership…”
          </span>
          <span className='reviewText'>
            “In our first meeting, NextDeavor came in with all these insights about the Bay Area, our role, and the demographic —
            it was so detailed. I was impressed that they had new knowledge to bring to me rather than just firing questions at
            me. We were able to have an organic conversation right away. I felt like it was a mutual partnership versus me just
            telling them what to do.”
          </span>
          <span className='reviewLogo'>
            <img src={Crunchyroll} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
